import React from "react";
import "./toggle.css";

const Toggle = ({
  isOn = false,
  onToggle = () => {},
  name = "",
  title = "",
  className = "",
}) => {
  return (
    <div className={`toggle-container ${className}`}>
      <input
        type="checkbox"
        id={name}
        className="toggle-input"
        checked={isOn}
        onChange={onToggle}
      />
      <label htmlFor={name} className="toggle-slider"></label>
    </div>
  );
};

export default Toggle;
